import React from 'react'
import Chip from '@mui/material/Chip'
import { EXPOSURE_OUTCOME } from '../labels'

const ExposureOutcomeChip = ({ outcome, ...props }) => {
  const config = EXPOSURE_OUTCOME[outcome || 'not_assessed'] || { label: outcome, color: 'default' }
  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ borderRadius: 1, fontWeight: 700 }}
      {...props}
    />
  )
}

export default ExposureOutcomeChip
